export const HE_LOCALES = {
  ACCEPT_COOKIES: 'לקבל עוגיות',
  CEMETERY_WEBSITE: 'אתר החברה',
  DOWNLOAD_FREE_MOBILE_APP: 'הורד את האפליקציה בחינם לנייד',
  FACEBOOK: 'פייסבוק',
  GO_TO_X_PAGE: '{X} עבור לדף',
  INDEX_PAGE: 'אינדקס',
  ON_OUR_WEBSITE_WE_USE_COOKIE:
    'באתר שלנו אנו משתמשים בעוגיות טכניות, אנליטיות, שיווקיות והעדפות. אלה נחוצים כדי שהאתר שלנו יפעל כראוי וכדי לתת לנו מידע על אופן השימוש באתר שלנו.',
  PHONE_NUMBER: 'טלפון / whatsapp',
  PRIVACY_POLICY: 'מדיניות פרטיות ותנאי השימוש',
  REJECT: 'לדחות עוגיות',
  SEARCH_BURIAL_RECORDS: 'חיפוש ברשומות הקבורה, בזיכרון',
  SERVICES: 'חידוש מצבה',
  THIS_WEBSITE_USES_COOKIES: 'אתר זה משתמש בקובצי Cookie',
};
